"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var withStyles_1 = require("../../../common/utils/withStyles");
var InlineIcon = function (_a) {
    var className = _a.className, icon = _a.icon, props = tslib_1.__rest(_a, ["className", "icon"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default(className, styles_scss_1.default.icon), role: "presentation" }, props), icon));
};
InlineIcon.propTypes = {
    className: prop_types_1.default.string,
    icon: prop_types_1.default.node,
};
exports.default = withStyles_1.withStyles(styles_scss_1.default)(InlineIcon);
//# sourceMappingURL=inline-icon.js.map